import React from "react";
import Button from "../../../../form/Button";
import HomeTable from "./HomeTable";
import BitCoin from "../../../../../assets/image/bitcoin.png";
import Ethereum from "../../../../../assets/image/ethereum.png";
import LiteCoin from "../../../../../assets/image/litecoin.png";
import Ripple from "../../../../../assets/image/ripple.png";

const HomeBanner = () => {

  const tableHeadData = [
    { id: 1, label: "Coin" },
    { id: 2, label: "Name" },
    { id: 3, label: "Amount" },
    { id: 4, label: "Chart" },
    { id: 5, label: "Action" },
  ];

  const tableData = [
    {
      id: 1,
      icon: BitCoin,
      coin: "Bitcoin",
      name: "Cruppto Network",
      amount: "+$3,000",
      chart: "fa-light fa-arrow-trend-up",
      action: "SELL",
    },
    {
      id: 2,
      icon: Ethereum,
      coin: "Ethereum",
      name: "Cruppto Network",
      amount: "+$2,100",
      chart: "fa-light fa-arrow-trend-down",
      action: "BUY",
    },
    {
      id: 3,
      icon: LiteCoin,
      coin: "Litecoin",
      name: "Cruppto Network",
      amount: "+$2,100",
      chart: "fa-light fa-arrow-trend-down",
      action: "SELL",
    },
    {
      id: 4,
      icon: Ripple,
      coin: "Ripple",
      name: "Cruppto Network",
      amount: "+$2,100",
      chart: "fa-light fa-arrow-trend-down",
      action: "BUY",
    },
    {
      id: 5,
      icon: Ethereum,
      coin: "Ethereum",
      name: "Cruppto Network",
      amount: "+$2,100",
      chart: "fa-light fa-arrow-trend-up",
      action: "BUY",
    },
    {
      id: 6,
      icon: Ethereum,
      coin: "Ethereum",
      name: "Cruppto Network",
      amount: "+$2,100",
      chart: "fa-light fa-arrow-trend-up",
      action: "BUY",
    },
  ];

  return (
    <section className="relative mt-32">
      <div className="w-full max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto">
        <div className="absolute inset-0 mx-auto w-full 2xl:w-[1500px] h-[1500px] rounded-full bg-radial-custom z-0 left-0 right-0"></div>
        <div className="relative max-w-8xl pt-32 mx-auto">
          <h1 className="font-bold text-white font-Poppins text-7xl 2xl:text-8xl text-center leading-[6rem] 2xl:leading-[7rem]">
            Empowering the next generation of <span className="text-primary">Trihust tech</span>
          </h1>
        </div>
        <div className="max-w-[780px] w-full mx-auto my-7 2xl:my-10 relative">
          <p className="font-Poppins font-medium text-white text-xl text-center">
            We provide a comprehensive long-term rental platform tailored for cryptocurrency users, leveraging blockchain technology to deliver a secure and seamless rental experience.
          </p>
        </div>
        <div className="relative z-0 order-1 xls:order-2 flex items-center gap-3 justify-center my-20 2xl:my-24">
          <Button
            buttonClasses={"!px-3 md:!px-7"}
            buttonHasLink={false}
            buttonLabel={"Buy Crypto"}
            buttonLabelClasses={
              "!text-xs md:!text-lg whitespace-nowrap uppercase font-semibold text-white text-stroke-2-primary"
            }
          />
          <Button
            buttonClasses={"!px-3 md:!px-7 !bg-buttonRed !border-borderButtonRed"}
            buttonHasLink={false}
            buttonLabel={"Sell Crypto"}
            buttonLabelClasses={
              "!text-xs md:!text-lg whitespace-nowrap uppercase font-semibold text-white text-stroke-2-borderButtonRed"
            }
          />
        </div>

        <section className="max-w-[1190px] w-full mx-auto bg-[#101406] border-2 border-slate-400 rounded-3xl overflow-hidden p-8 relative">
          <HomeTable
            tableHeadData={tableHeadData}
            tableData={tableData}
            isLoader={false}
          />
        </section>
      </div>
    </section>
  );
};

export default HomeBanner;
